module.exports = __webpack_public_path__ + "img/88fcbae66da924f17a58680231732555.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/mpura_logo.png
// module id = 246
// module chunks = 0